module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "mint-button-list-title mt-color-grey-lv3"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "mint-button-list-button-container mt-bg-lv3"
  }, [_vm._l((_vm.options), function(item) {
    return [_c('mt-button', {
      key: item.id,
      staticClass: "mint-button-list-btn",
      attrs: {
        "plain": _vm.plain,
        "size": "normal",
        "type": _vm.getType(item.id)
      },
      on: {
        "click": function($event) {
          _vm.handleClick(item.id, $event)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8831f9","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/button-list/src/button-list.vue
// module id = 380
// module chunks = 0